<template>
  <div>
    <div class="nav-pagination">
      <div class="container">
        <hr class="hraing" />
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="sooper-text">
              <h4>Guides</h4>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 text-right nav-pagination1">
            <ul>
              <li>
                <a href="index.html">Content</a>
              </li>
              <li>|</li>
              <li>Guides</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="container blog">
      <div class="column">
        <div class="col-md-7">
          <div class="row">
            <div v-for="p in paginatedData" :key="p.name" class="col-md-12">
              <router-link :to="'/Guide/'+p.name+'?post_id='+p.post_id">
                <div class="blog-text wow animated slideInUp">
                  <img v-bind:src="p.image" class="img-responsive img-blog" v-bind:alt="p.image" />
                  <br />
                  <h4>{{p.name}}</h4>
                  <h5>{{p.catagory}}</h5>
                  <p class="blog-para">{{p.summary}}</p>
                </div>
                <br />
              </router-link>
            </div>
          </div>
          <a
            style="margin-bottom: 50px;"
            :disabled="pageNumber==0"
            class="btn btn-primary button6"
            @click="prevPage"
          >Previous Page</a>
          <a
            style="margin-bottom: 50px;"
            :disabled="pageNumber==0"
            class="btn btn-primary button6"
            @click="nextPage"
          >Next Page</a>
        </div>
      </div>
      <div class="column">
        <div class="col-md-5">
          <div class="blog-text wow animated slideInUp">
            <h4>About</h4>
            <p
              class="blog-para"
            >We have made a number of guides to help small to medium sized business get started with Business Intelligence.</p>
          </div>
        </div>
      </div>
    </div>

    <section class="newsletter">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="heading text-center newsletter1 wow animated slideInUp">
              <h3>Subscribe to our newsletter</h3>
              <p>Join our mailing list and get updates on our articles, case studies & promotions</p>
            </div>
            <form class="form-inline forms text-center" action="index.html">
              <div class="form-group">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  size="32"
                  class="form-control wow animated slideInLeft"
                  id="email"
                />
              </div>
              <button
                type="button"
                class="btn btn-subscribe wow animated slideInRight"
              >Subscribe now</button>
            </form>
          </div>

          <div v-show="screensize === false" class="row">
            <div class="col-md-12">
              <div class="heading text-center wow animated slideInUp">
                <h3>
                  <br />Don't miss any updates
                </h3>
                <h3>Follow us:</h3>
              </div>
            </div>
            <div class="col-md-4">
              <div class="social instagram text-center wow animated slideInLeft">
                <h4>Follow Us On Instagram</h4>
                <p class="color-p">Content, News & Photos</p>
                <p class="in">
                  <a href>
                    <span>
                      <i class="fa fa-instagram"></i>
                    </span> Instagram.com
                  </a>
                </p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="social linkedin text-center wow animated bounce">
                <h4>Follow Us On LinkedIn</h4>
                <p class="color-p">Content, News & Jobs</p>
                <p class="ln">
                  <a href>
                    <span>
                      <i class="fa fa-linkedin"></i>
                    </span> LinkedIn.com
                  </a>
                </p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="social twitter text-center wow animated slideInRight">
                <h4>Follow Us On Twitter</h4>
                <p class="color-p">Content, News & Thoughts</p>
                <p class="twitt">
                  <a href>
                    <span>
                      <i class="fa fa-twitter"></i>
                    </span> Twitter.com
                  </a>
                </p>
              </div>
            </div>
            <div class="clear-fix"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Guides",
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "Guides on the topics of Business Analytics, Data Science, Machines Learning & AI, Data Management and Technology."
      }
    ],
    htmlAttrs: {
      lang: "en"
    },
    title: "Business Intelligence Guides",
    // override the parent template and just use the above title only
    titleTemplate: null
  },
  data: function() {
    return {
      scrolled: true,
      posts: [],
      pageNumber: 0,
      screensize: null
    };
  },
  props: {
    postsData: {
      type: Array,
      required: true
    },
    size: {
      type: Number,
      required: false,
      default: 3
    }
  },
  components: {},
  computed: {
    pageCount() {
      let l = this.posts.length,
        s = this.size;
      return Math.ceil(l / s);
    },

    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      return this.posts.slice(start, end);
    }
  },
  created: function() {
    const contentful = require("contentful");
    const client = contentful.createClient({
      // This is the space ID. A space is like a project folder in Contentful terms
      space: "055zjod1n9jp",
      // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
      accessToken: "TagtkY-mvVnDjYZExfWoe5ITe-7GUHdI6bwFWTXsOUA"
    });

    client
      .getEntries({
        content_type: "guide"
      })
      .then(response => {
        console.log(response);
        var postcount = response.items.length;
        this.posts = [];
        if (postcount > 0) {
          response.items.map(postData => {
            this.posts.push({
              name: postData.fields.title,
              catagory: postData.fields.category,
              image: postData.fields.image.fields.file.url,
              summary: postData.fields.description,
              post_id: postData.sys.id
            });
          });
        }
      })
      .catch(console.error);

    if (screen.width < 700) {
      this.screensize = true;
    } else {
      this.screensize = false;
    }
  },
  beforeDestroy() {
    window.analytics.page("Guides");
  },
  methods: {
    nextPage() {
      this.pageNumber++;
      scrollTo(0, 225);
    },
    prevPage() {
      this.pageNumber--;
      scrollTo(0, 225);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
